<template>
	<div id="app" style="height: 0vh">
		<v-app>
			<the-header v-if="$route.name !== 'The404Page'"> </the-header>
			<v-main>
				<router-view :key="$route.fullPath" />
			</v-main>
			<the-footer v-if="$route.name !== 'The404Page'"> </the-footer>
		</v-app>
	</div>
</template>

<script>
import TheHeader from './layout/TheHeader.vue'
import TheFooter from './layout/TheFooter.vue'

export default {
	name: 'App',
	metaInfo: {
		title: '',
		titleTemplate: '%s | Nsquare Herbal',
	},
	components: {
		TheHeader,
		TheFooter,
	},
}
</script>

<style>
.v-application--wrap {
	min-height: 0vh !important;
}
.w-full {
	width: 100%;
}
.line-clamp-2 {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.line-clamp-2 > * {
	display: inline;
	visibility: visible;
}

/*.line-clamp-2 > * > * */
.line-clamp-2 > * + * {
	display: inline;
	visibility: hidden;
}
main {
	min-height: 100vh;
	height: auto;
}
.v-toolbar__content {
	padding: 0 !important;
}
</style>